module.exports = __webpack_public_path__ + "img/FGr_FK.5858d723.svg";